// import { updateVisibility } from "@actions/showHideWidgets";
import { openHomepage } from "@actions/openHomepage";
import { updateDashcamAddress } from "@actions/updateDashcamAddress";
import { store } from "@store/store";
import { updatePropsAction } from "@actions/updateProps";

export const showLoaderAndRedirectToHomepage = async (args: any) => {
  const { loader_id, link, reverseIds } = args;
  const homepageLink = link || "https://ackoapp.onelink.me/Tlwi/sngilefw";

  const { globalState } = store?.getState() || {};
  const payloadData = globalState?.payloadData || {};

  try {
    await updateDashcamAddress(payloadData);
    if (reverseIds && Array.isArray(reverseIds)) {
      reverseIds.forEach((component_id: string) => {
        updatePropsAction({
          component_id: component_id,
          update_props: { is_visible: false }
        });
      });
    }
    if (loader_id) {
      updatePropsAction({
        component_id: loader_id,
        update_props: { is_visible: true }
      });
    }

    await new Promise((resolve) => setTimeout(resolve, 2000));

    openHomepage({ link: homepageLink });
  } catch (error) {
    console.error("showLoaderAndRedirectToHomepage Error:", error);
  }
};
